import { proxy } from 'valtio';

import type { SearchUiState } from '@/integrations/algolia/types';

export type ListingType = 'WATCH' | 'STRAP' | 'STORE' | 'EYEWEAR';

type ModalState = {
  openedTab: string | null;
  status: 'OPEN' | 'CLOSE';
};

type ListingState = {
  listingType: ListingType | '';
  modalState: ModalState;
  uiState: SearchUiState;
};

export const listingActions = {
  updateModalState: (modalState: Partial<ModalState>) => {
    listingState.modalState = { ...listingState.modalState, ...modalState };
  },

  updateListingType: (listingType: ListingType) => {
    listingState.listingType = listingType;
  },

  updateSearchState: (searchState: SearchUiState) => {
    delete searchState.configure;
    listingState.uiState = searchState;
  },
};

export const listingState = proxy<ListingState>({
  modalState: { status: 'CLOSE', openedTab: null },
  listingType: '',
  uiState: {},
});
